import GRWorldpayLogo from '@/app/images/logos/GRWorldpay-logo.png'
import GreenlinePOSFull from '@/app/images/logos/GreenlinePOS-full.svg'
import GreenlineDarkBgTransGreenText from '@/app/images/logos/Greenline_darkBG-trans-green-text.svg'
import GreenlineDarkBgTransWhtText from '@/app/images/logos/Greenline_darkBG-trans-wht-text.svg'
import Greenline2025DKPNG from '@/app/images/logos/Greenline2025-DK.png'
import Greenline2025DKSVG from '@/app/images/logos/Greenline2025-DK.svg'
import AglcLogo from '@/app/images/logos/aglc-logo.svg'
import BlazeBrandingLogo from '@/app/images/logos/blaze-branding-logo.svg'
import BlazeEcomBlockLogo from '@/app/images/logos/blaze_ecom_block_logo.svg'
import BlazeLogoFlatBlack from '@/app/images/logos/BLAZE-Logo-Flat-Black.svg'
import BlazeLogoFlatWhite from '@/app/images/logos/BLAZE-Logo-Flat-White.svg'
import BlazeLogoFlatAllBlue from '@/app/images/logos/BLAZE-Logo-Flat-allBlue.svg'
import BlazeLogoBlue from '@/app/images/logos/BLAZE-Logo-blue.svg'
import BlazeLogoFullColorDark from '@/app/images/logos/BLAZE-Logo-fullColor-DK_1.svg'
import BlazeLogoFullColorLight from '@/app/images/logos/BLAZE-Logo-fullColor-LT_1.svg'
import BlazeLogoWhite from '@/app/images/logos/BLAZE-Logo-white.svg'
import Blazepay from '@/app/images/logos/blazepay.png'
import GreenlineCapital from '@/app/images/logos/greenline-capital.png'
import GreenlineLogoWhite from '@/app/images/logos/greenline-logo-white.svg'
import GreenlineLogo from '@/app/images/logos/greenline-logo.svg'
import GreenlineNewLogo from '@/app/images/logos/greenline-new-logo.svg'
import Logo256 from '@/app/images/logos/logo-256.png'
import SmsOutreach from '@/app/images/logos/sms-outreach.svg'
import Birchmount from '@/app/images/logos/birchmount.png'
import Datacandy from '@/app/images/logos/datacandy.png'
import Paystone from '@/app/images/logos/paystone.png'
import GrGiftcard from '@/app/images/logos/img-gr-gift-card.png'
import BuddiLogo from '@/app/images/logos/buddi-logo.png'
import BuddiScreen from '@/app/images/logos/buddi-screen.png'
import BudvueLogo from '@/app/images/logos/budvue-logo.png'
import BudvueScreenshot from '@/app/images/logos/budvue-screenshot.png'
import HeadsetInfo from '@/app/images/logos/headset-info.png'
import HeadsetLogo from '@/app/images/logos/headset-logo.png'
import InappdynamicsLogo from '@/app/images/logos/inappdynamics-logo.png'
import MerrcoLogo from '@/app/images/logos/merrco-logo.svg'
import TrybudtenderLogo from '@/app/images/logos/trybudtender-logo.png'
import TrybudtenderScreen from '@/app/images/logos/trybudtender-screen.png'
import BannerCanadaDay from '@/app/images/logos/banner-canada-day.png'
import QuickBooksLogo from '@/app/images/logos/C2QB_green_btn_lg_default.png'
import BlazeSiteBlockLogo from '@/app/images/logos/blaze_site_block_logo.svg'
import BlazepayBlockLogo from '@/app/images/logos/blazepay_block_logo.svg'
import { AppType, GlobalStore } from '@/app/stores/GlobalStore'

export class Logos {
  static get shiftPageLoginBanner() {
    switch (GlobalStore.appType) {
      case AppType.BLAZEPOS:
        return BlazeLogoFullColorDark
      default:
        return Greenline2025DKPNG
    }
  }

  static get landingPageLoginBanner() {
    switch (GlobalStore.appType) {
      case AppType.BLAZEPOS:
        return BlazeLogoFullColorDark
      default:
        return Greenline2025DKPNG
    }
  }

  static get sidebarLogo() {
    switch (GlobalStore.appType) {
      case AppType.BLAZEPOS:
        return BlazeLogoFullColorDark
      default:
        return Greenline2025DKSVG
    }
  }

  static readonly grWorldpayLogo = GRWorldpayLogo
  static readonly greenlinePOSFull = GreenlinePOSFull
  static readonly greenlineDarkBgTransGreenText = GreenlineDarkBgTransGreenText
  static readonly greenlineDarkBgTransWhtText = GreenlineDarkBgTransWhtText
  static readonly aglcLogo = AglcLogo
  static readonly blazeBrandingLogo = BlazeBrandingLogo
  static readonly blazeEcomBlockLogo = BlazeEcomBlockLogo
  static readonly blazeLogoFlatBlack = BlazeLogoFlatBlack
  static readonly blazeLogoFlatWhite = BlazeLogoFlatWhite
  static readonly blazeLogoFlatAllBlue = BlazeLogoFlatAllBlue
  static readonly blazeLogoBlue = BlazeLogoBlue
  static readonly blazeLogoFullColorDark = BlazeLogoFullColorDark
  static readonly blazeLogoFullColorLight = BlazeLogoFullColorLight
  static readonly blazeLogoWhite = BlazeLogoWhite
  static readonly blazepayBlockLogo = BlazepayBlockLogo
  static readonly blazepay = Blazepay
  static readonly greenlineCapital = GreenlineCapital
  static readonly blazeSiteBlockLogo = BlazeSiteBlockLogo
  static readonly greenlineLogoWhite = GreenlineLogoWhite
  static readonly greenlineLogo = GreenlineLogo
  static readonly greenlineNewLogo = GreenlineNewLogo
  static readonly logo256 = Logo256
  static readonly smsOutreach = SmsOutreach
  static readonly birchmount = Birchmount
  static readonly datacandy = Datacandy
  static readonly grGiftcard = GrGiftcard
  static readonly paystone = Paystone
  static readonly buddiLogo = BuddiLogo
  static readonly buddiScreen = BuddiScreen
  static readonly budvueLogo = BudvueLogo
  static readonly budvueScreenshot = BudvueScreenshot
  static readonly headsetInfo = HeadsetInfo
  static readonly headsetLogo = HeadsetLogo
  static readonly inappdynamicsLogo = InappdynamicsLogo
  static readonly merrcoLogo = MerrcoLogo
  static readonly trybudtenderLogo = TrybudtenderLogo
  static readonly trybudtenderScreen = TrybudtenderScreen
  static readonly bannerCanadaDay = BannerCanadaDay
  static readonly quickBooksLogo = QuickBooksLogo

  private constructor() {}
}
